export default function useApi(slug: string, controller: General.Controllers.Salon): General.Models.Salon.Api {
    const ebook = () => controller.ebook(slug)

    return {
        ebook
    }
}